export default "/images/eugene_prystupa.jpg?80ef68250f348ac4f1f1e5f971fb782d";